/** Home's path. /home is the House app, so Home lives at /overview. */
export const HOME_ROUTE = '/overview'
